/**
 * Maps the font sizes of pasted headings to heading levels, largest first.
 * One size becomes h3, two become h2 and h3, and so on up to h1.
 */
export const headingLevels = (sizes: number[]) => {
  const distinct = [...new Set(sizes)].sort((a, b) => b - a)
  const firstLevel = Math.max(1, 4 - distinct.length)

  return new Map(
    distinct.map((size, rank) => [size, Math.min(6, firstLevel + rank)])
  )
}
